import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';
import * as moment from 'moment';


@Component({
  selector: 'app-monthly-attendance-staff',
  templateUrl: './monthly-attendance-staff.component.html',
  styleUrls: ['./monthly-attendance-staff.component.css']
})
export class MonthlyAttendanceStaffComponent implements OnInit {
  Submitted: boolean = false;
  StaffMonthlyAttendanceList: any;
  CurrentStatusHeader: any;
  EmployeeCategoryList = [];
  YearList = [];
  MonthlyAttendance = [];
  LeaveTypeList = [];

  constructor(private payrollService: HrService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  StaffMonthlyAttendanceModel = {
    EmployeeCategoryID: 0,
    PrimaryDepartmentID: 0,
    DesignationID: 0,
    StartDate: '',
    EndDate: '',
    StaffIdentity: '',
  }

  ClearSearch() {
    this.StaffMonthlyAttendanceModel.EmployeeCategoryID = 0;
    this.StaffMonthlyAttendanceModel.PrimaryDepartmentID = 0;
    this.StaffMonthlyAttendanceModel.DesignationID = 0;
    this.StaffMonthlyAttendanceModel.StartDate = '';
    this.StaffMonthlyAttendanceModel.EndDate = '';
    this.StaffMonthlyAttendanceModel.StaffIdentity = '';
    this.StaffMonthlyAttendanceList = [];
    this.Submitted = false;
  }



  FieldValidation() {
    return this.StaffMonthlyAttendanceModel.StartDate == '' || this.StaffMonthlyAttendanceModel.EndDate == '';
  }


  GetStaffMonthlyAttendance() {
    this.Submitted = true
    if (!this.FieldValidation()) {
      this.Submitted = false;
      this.spinnerService.show();
      this.StaffMonthlyAttendanceModel.StartDate = this.StaffMonthlyAttendanceModel.StartDate != null && this.StaffMonthlyAttendanceModel.StartDate != '' ? moment(this.StaffMonthlyAttendanceModel.StartDate).format('DD-MMM-YYYY') : '';
      this.StaffMonthlyAttendanceModel.EndDate = this.StaffMonthlyAttendanceModel.EndDate != null && this.StaffMonthlyAttendanceModel.EndDate != '' ? moment(this.StaffMonthlyAttendanceModel.EndDate).format('DD-MMM-YYYY') : '';

      this.payrollService.GetStaffMonthlyAttendance(JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
        if (data.StaffMonthlyAttendanceList != null) {
          this.StaffMonthlyAttendanceList = data.StaffMonthlyAttendanceList;
          this.MonthlyAttendance = this.StaffMonthlyAttendanceList[0].DayList;
          this.CurrentStatusHeader = data.CurrentStatusHeader;
         
        }
        this.spinnerService.hide();
      });
    }
  };




  ngOnInit() {
    this.GetEmployeeCategory();
    this.GetDepartment();
    this.GetDesignation();
    this.GetLeaveType();

  }

  GetEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });
  };


  GetLeaveType() {
    this.lookupservice.GetLookupsList('LeaveType', '').subscribe((data: any) => {
      this.LeaveTypeList = data.LookupItems;
      this.LeaveTypeList.splice(0, 1);
    });
  };


  ListDepartment = []
  GetDepartment() {
    this.lookupservice.GetLookupsList('Department', '').subscribe((data: any) => {
      this.ListDepartment = data.LookupItems;
    });
  }

  DesignationList = []
  GetDesignation() {
    this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
      this.DesignationList = data.LookupItems;
    });
  };

  // Download

  FilePath: any
  GetStaffMonthlyAttendanceDownload() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      this.spinnerService.show();

      this.payrollService.GetStaffMonthlyAttendanceDownload(JSON.stringify(this.StaffMonthlyAttendanceModel)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.Submitted = false;
        this.FilePath = data.FilePath;
        if (data.webResponse != null)
          if (data.FilePath != null)
            window.location = data.FilePath;

      });
    }

  };

  // Print


  GetStaffMonthlyAttendancePrint() {
    this.Submitted = true;
    if (!this.FieldValidation()) {
      this.spinnerService.show();
      var url = "MonthlyAttendancePrint?EmployeeCategoryID" + this.StaffMonthlyAttendanceModel.EmployeeCategoryID + '&PrimaryDepartmentID=' + this.StaffMonthlyAttendanceModel.PrimaryDepartmentID + '&DesignationID=' + this.StaffMonthlyAttendanceModel.DesignationID + '&StaffIdentity=' + this.StaffMonthlyAttendanceModel.StaffIdentity + '&StartDate=' + this.StaffMonthlyAttendanceModel.StartDate + '&EndDate=' + this.StaffMonthlyAttendanceModel.EndDate;
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
      this.spinnerService.hide();
      this.Submitted = false;
    };
  }



}
